import React from 'react';

function ToggleButton(props) {
	return (
		<calcite-button
			appearance="outline"
			color={props.selected ? 'blue' : 'neutral'}
			kind={props.selected ? 'brand' : 'neutral'}
			scale="l"
			onClick={props.onClick}
			class={`${props.className}`}
			{...props.customAttributes}>
			<div className="toggle-button-content">{props.children}</div>
		</calcite-button>
	);
}

export default ToggleButton;
